import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const Wrapper = styled.div`
	padding: ${helpers.spacing.small};

	${mobileMediaQuery(css`
		padding: 0;
	`)}
`
